import { useLanguage } from '@/src/contexts';
import { getText } from '@/src/helpers';
import { useFireblockVaultAccountAssetAddressAtIndex, useSelectedTokens } from '@/src/hooks';
import { TradingSection } from '@/src/ui-components';
import { useFormContext } from 'react-hook-form';
import { TradingFormValues } from '../../trading.types';
import { useTokenBalance } from '../trade-panel/hooks/use-token-balance';
import { TokenBalance } from './token-balance';

export const Balances = () => {
  const { language } = useLanguage();

  const { watch } = useFormContext<TradingFormValues>();
  const { baseTokenId, quoteTokenId } = watch();
  const [baseToken, quoteToken] = useSelectedTokens(baseTokenId, quoteTokenId);
  const { vaultAccountAssetAddress } = useFireblockVaultAccountAssetAddressAtIndex();

  const baseTokenBalance = useTokenBalance({
    token: baseToken,
    address: vaultAccountAssetAddress?.address,
  });
  const quoteTokenBalance = useTokenBalance({
    token: quoteToken,
    address: vaultAccountAssetAddress?.address,
  });

  return (
    <TradingSection>
      <TradingSection.Header>
        <TradingSection.Title>{getText(language, 'yourBalances')}</TradingSection.Title>
      </TradingSection.Header>
      <TradingSection.Body className="space-y-2 h-auto">
        <TokenBalance token={baseToken} balance={baseTokenBalance} />
        <TokenBalance token={quoteToken} balance={quoteTokenBalance} />
      </TradingSection.Body>
    </TradingSection>
  );
};
